"use strict";

import {gh} from '../general/general-helpers';

(function( $ ) {
	// Only for single-video post type
	if ( document.body.classList.contains( 'single-guide' ) ) {


		/* Init Table of Contents slider
		-------------------------------------------------------------------*/
		document.addEventListener( 'DOMContentLoaded', function() {

			const slider_el = $( '#guide-toc-slider' );

			// Options
			let options = {
				margin:     0,
				dots:       true,
				nav:        true,
				loop:       false,
				autoHeight: true,
				items:      1,
				navContainerClass: 'owl-nav spacer-mt-0',
				navText:    [
					gh.owlSliderCustomNavArrows( 'mobile', true, 'color-accent', false ),
					gh.owlSliderCustomNavArrows( 'mobile', false, 'color-accent', false ),
				],
				smartSpeed: 500,
			};

			function initOrDestroySlider() {
				if ( ! gh.isDesktopDesign ) {
					tocSliderRun( true ); // init
					return;
				}
				tocSliderRun(); // destroy
			}

			function tocSliderRun( init ) {
				// DESTROY
				if ( !init ) {
					// init slider and add classes
					slider_el.trigger('destroy.owl.carousel').removeClass('owl-carousel owl-theme owl-loaded owl-drag');
					slider_el.find('.owl-stage-outer').children().unwrap();
					// unwrap links
					slider_el.find( '.guide-toc-slider__item' ).children().unwrap();
					return;
				}

				// INIT
				// wrap links
				const linkDivs = $( '.guide-nav__link-wrap' );
				for ( let i = 0; i < linkDivs.length; i += 5 ) {
					linkDivs.slice( i, i + 5 ).wrapAll( '<div class="guide-toc-slider__item"></div>' );
				}
				// init slider and add classes
				slider_el.addClass( 'owl-carousel owl-theme' );
				slider_el.owlCarousel( options );
			} // FNC

			// inits or destroys the slider only when screen width changes
			document.addEventListener( 'designChange', () => {
				initOrDestroySlider();
			} );

			// init slider on page load
			initOrDestroySlider();
		} );

		/* Author slider
		-------------------------------------------------------------------*/
		gh.initAuthorsSlider();


		/* Posts tag slider
		-------------------------------------------------------------------*/
		// init the slider
		window.addEventListener( 'load', function() {
			gh.rowNavSliderInit( $( '.post-tags-slider' ) );
		} );

	} // IF this page
})( jQuery );

